{
  "Administrator": "Administrator:",
  "AdministratorRole": "Administratorrolle:",
  "AdministratorLanguage_ServiceNotification": "Servicebenachrichtigung:",
  "AdministratorLanguage_ConcurrentSignins": "Gleichzeitige Anmeldungen zulässig:",
  "NAME": "AdministratorLanguage"
}